import React, { FC, useMemo } from 'react';
import { useLanguageContext } from 'store/language';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { ITableFilter } from 'components/table/types';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import API from 'core/Api';
import ManuallyInsert from '../../components/ManuallyInsert';

interface ISelectOptionProps {
  label: string;
  value: string | number | boolean;
}

interface IFormDropdowns {
  types: ISelectOptionProps[];
  paid_sub_types: ISelectOptionProps[];
  additional_sub_types?: ISelectOptionProps[];
  substitute_employees?: ISelectOptionProps[];
}

const CreateForm: FC = () => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();
  const { language } = useLanguageContext();

  const {
    isFetching,
    isLoading: isLoadingLeavesDropdowns,
    error: errorDropdowns,
    data: dropdowns,
  } = useQuery<{ [key: string]: ISelectOptionProps[] }, Error>(
    [buildClientEntity('leaves-dropdowns', client)],
    (): Promise<{ [key: string]: ISelectOptionProps[] }> => {
      return API.get('leaves/dropdown-options?all-users=true').then(res => {
        const filters = res.data && res.data[language || 'bg'];
        return {
          ...filters,
          status: filters.status.map((filter: ITableFilter) => {
            if (
              filter.value === 'rejected' ||
              filter.value === 'confirmed' ||
              filter.value === 'employeeRejectInitiated'
            )
              return {
                ...filter,
                selected: true,
              };

            return filter;
          }),
        };
      });
    },
    {
      cacheTime: 0,
    }
  );

  const {
    isLoading: isLoadingFormDropdowns,
    error: errorFormDropdowns,
    data: ManuallyInsertFormDropdowns,
  } = useQuery<IFormDropdowns, Error>(
    [buildClientEntity('employee-leaves-dropdowns', client)],
    (): Promise<IFormDropdowns> => {
      return API.get('leaves/types/dropdown-options?all=true').then(
        res =>
          res.data && {
            ...res.data,
          }
      );
    }
  );

  const FormDropdowns = useMemo(() => {
    return {
      user: dropdowns?.user,
      types: ManuallyInsertFormDropdowns?.types,
      paidSubTypes: ManuallyInsertFormDropdowns?.paid_sub_types,
      additionalSubTypes: ManuallyInsertFormDropdowns?.additional_sub_types,
      substituteEmployees: ManuallyInsertFormDropdowns?.substitute_employees,
    };
  }, [ManuallyInsertFormDropdowns, dropdowns]);

  return (
    <ManuallyInsert
      title={t('leaves.manuallyInsertLeaveCreate')}
      dropdowns={FormDropdowns}
    />
  );
};

export default CreateForm;
